import React from "react";
import { Route, Routes } from "react-router-dom";
import EBillProviderCreateScreen from "screens/App/CRM/EBillProvider/EBillProviderCreateScreen";
import EBillProviderDetailScreen from "screens/App/CRM/EBillProvider/EBillProviderDetailScreen";
import EBillProviderEditScreen from "screens/App/CRM/EBillProvider/EBillProviderEditScreen";
import EBillProviderListScreen from "screens/App/CRM/EBillProvider/EBillProviderListScreen";
import NotFoundScreen from "screens/NotFoundScreen";


const EBillProviderRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<EBillProviderCreateScreen />} />
            <Route path="list" element={<EBillProviderListScreen />} />
            <Route path=":id/detail" element={<EBillProviderDetailScreen />} />
            <Route path=":id/edit" element={<EBillProviderEditScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default EBillProviderRouter;
